import { createReducer } from "sc/helpers/reducer";
import {
  ENGINEER_PAGE_LOADED,
  ENGINEER_EMAIL_DELETE_REQUEST,
  ENGINEER_EMAIL_DELETED,
  ENGINEER_EMAIL_ADD_REQUEST,
  ENGINEER_EMAIL_ADDED,
  ENGINEER_UPDATE_REQUEST,
  ENGINEER_UPDATED,
  ENGINEER_ADD_REQUEST,
  ENGINEER_ADD_ERROR,
  ENGINEER_UPDATE_ERROR,
  ENGINEER_EMAIL_ADD_ERROR,
  ENGINEER_EMAIL_DELETE_ERROR,
} from "../actions/engineers";
import { LOCATION_CHANGE } from "react-router-redux/reducer";

export default createReducer(null, {
  [LOCATION_CHANGE]: (state, action) => null,
  [ENGINEER_PAGE_LOADED]: (state, action) => {
    const { emails, ...generalData } = action.payload.engineer;
    const emailsWithState = emails.map(email => ({
      value: email,
      deleteInProgress: false,
    }));
    return Object.assign({}, generalData, {
      emails: emailsWithState,
      emailAddInProgress: false,
      generalDataSaveInProgress: false,
    });
  },
  [ENGINEER_ADD_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      generalDataSaveInProgress: true,
      generalDataError: "",
    }),
  [ENGINEER_ADD_ERROR]: (state, action) =>
    Object.assign({}, state, {
      generalDataSaveInProgress: false,
      generalDataError: action.payload.message,
    }),
  [ENGINEER_UPDATE_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      generalDataSaveInProgress: true,
      generalDataError: "",
    }),
  [ENGINEER_UPDATE_ERROR]: (state, action) =>
    Object.assign({}, state, {
      generalDataSaveInProgress: false,
      generalDataError: action.payload.message,
    }),
  [ENGINEER_UPDATED]: (state, action) =>
    Object.assign({}, state, { generalDataSaveInProgress: false }),
  [ENGINEER_EMAIL_ADD_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      emailAddInProgress: true,
      emailAddError: "",
    }),
  [ENGINEER_EMAIL_ADD_ERROR]: (state, action) =>
    Object.assign({}, state, {
      emailAddInProgress: false,
      emailAddError: action.payload.message,
    }),
  [ENGINEER_EMAIL_ADDED]: (state, action) => {
    const { emails, ...generalData } = state;
    const updatedList = [
      ...emails,
      { value: action.payload.email, deleteInProgress: false },
    ];
    return Object.assign({}, generalData, {
      emails: updatedList,
      emailAddInProgress: false,
    });
  },
  [ENGINEER_EMAIL_DELETE_REQUEST]: (state, action) => {
    const { emails, ...generalData } = state;
    const updatedList = emails.map(email => ({
      value: email.value,
      deleteInProgress:
        email.value === action.payload.email ? true : email.deleteInProgress,
    }));
    return Object.assign({}, generalData, { emails: updatedList });
  },
  [ENGINEER_EMAIL_DELETE_ERROR]: (state, action) => {
    const { emails, ...generalData } = state;
    const updatedList = emails.map(email => ({
      value: email.value,
      deleteInProgress:
        email.value === action.payload.email ? false : email.deleteInProgress,
    }));
    return Object.assign({}, generalData, { emails: updatedList });
  },
  [ENGINEER_EMAIL_DELETED]: (state, action) => {
    const { emails, ...generalData } = state;
    const updatedList = emails.filter(
      email => email.value !== action.payload.email,
    );
    return Object.assign({}, generalData, { emails: updatedList });
  },
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/reducers/engineer-reducer.js